import { gql } from '@/Types/gql';

export const GET_ALL_SESSIONS = gql(`
   query GetAllSession($search: String, $filter: JSON, $sort: JSON, $limit: Int, $offset: Int) {
    getAllSession(search: $search, filter: $filter, sort: $sort, limit: $limit, offset: $offset) {
        _id
        duration
        roomId
        sessionStartTime
        sessionEndTime
        sessionStatus
        sportId
        programId
        programName
        position
        sessionUniqId
        status
        trainerAssignedDateTime
        timeZone
        trainingType {
            _id
            icon
            title
            status
            order
        }
        trainerId
        trainerIdUser {
            _id
            firstName
            lastName
            profileImage
           
        }
        lastTrainerDtls {
          _id
          displayName
          firstName
          lastName
          profileImage
        }
        assesment {
          _id
          assessment
        }
        futureSessionImprovement
        targetedMuscle
        clientFeedback
        traineeId
        traineeIdUser {
        _id
        profileImage
        firstName
        lastName
         displayName
        }
        updatedAt
        subscriptionType
        trainerExpertiseRating
        createdById
        createdAt
        trainerFeedback
        clientPerformance
        exercisePerformed
        participantLogs {
          LogType
          participantId
          time
        }
    }
    getAllSessionCount(search: $search, filter: $filter)
}
`);

export const GET_ALL_TRAINING_TYPES = gql(`
    query GetAllTrainingTypeSessionListing($search: String, $filter: JSON, $sort: JSON, $limit: Int, $offset: Int) {
    getAllTrainingType(search: $search, filter: $filter, sort: $sort, limit: $limit, offset: $offset) {
        _id
        createdAt
        updatedAt
        title
        icon
        order
        status
    }
    }
`);

export const GET_ALL_SESSIONS_COUNT = gql(`
    query GetAllSessionsCount($search: String, $filter: JSON) {
        getAllSessionCount(search: $search, filter: $filter)
    }
`);

export const GET_ALL_TRAINING_TYPES_COUNT = gql(`
query Query($search: String, $filter: JSON) {
  getAllTrainingTypeCount(search: $search, filter: $filter)
}`);

export const GET_SESSION_BALANCE = gql(`
    query GetSessionBalance {
    getCurrentUser {
      sessionBalance
      fitCurveBalance
      fitPrimeBalance
      fitVarsityBalance
      freeSessionBalance
      ageRange

    }
  }
`);
